import HttpService from './http';

export default class TransactionHttpService {
  static get = async uid => {
    const url = `/v2.0/transactions/${uid}`;
    return await HttpService.get(url, true);
  };

  static getMyList = async event_uid => {
    const url = `/v2.0/transactions/event/${event_uid}/me`;
    return await HttpService.get(url, true);
  };

  static create = async payload => {
    const url = '/v2.0/transactions/create';
    return await HttpService.post(url, payload, true);
  };

  static charge = async payload => {
    const url = '/v2.0/transactions/charge';
    return await HttpService.post(url, payload, true);
  };

  static chargeAndCreate = async payload => {
    const url = '/v2.0/transactions/charge-create';
    return await HttpService.post(url, payload, true);
  };
}
